import BaseService from '_services/rest/base';

class ProjectService extends BaseService {
  constructor() {
    super();
  }

  deleteProject(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteProjectFile(param) {
    return this.request(`${this.getUrl()}/${param.projectId}/file/${param.fileId}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteStatus(id) {
    return this.request(`${this.getUrl()}/status/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  finishProject(id) {
    return this.request(`${this.getUrl()}/${id}/finish`, null, 'PATCH')
      .catch(err => {
        throw err;
      });
  }

  getFiles(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/${params.projectId}/files`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/project`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getProjectById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getProjectStatus() {
    return this.request(`${this.getUrl()}/status/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getAttachedProjectStatus(params) {
    return this.request(`${this.getUrl()}/${params.projectId}/status?group=${params.group}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(project) {
    const meta = this.getUrlSave(project.id);
    return this.request(meta.url, project, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveStatus(status) {
    const meta = this.getUrlSave(status.id, '/status');
    return this.request(meta.url, status, meta.method)
      .catch(err => {
        throw err;
      });
  }

  syncStatus(status, id) {
    return this.request(`${this.getUrl()}/${id}/status`, status, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  updateStatus(params) {
    const project = {
      id: params.id,
      status_id: params.status_id,
    };
    return this.request(`${this.getUrl()}/${params.id}/status`, project, 'PATCH')
      .catch(err => {
        throw err;
      });
  }

  uploadFile(params) {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('name', params.name);
    return this.request(`${this.getUrl()}/${params.id}/file`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ProjectService();
